// import React, { ChangeEvent } from "react";
import { FormControl, TextField } from "@mui/material";
import {
  useController,
  UseControllerReturn,
  useFormContext,
} from "react-hook-form";

export interface InputProps {
  name: string;
  placeholder?: string;
  label?: string;
  preventPaste?: boolean
  type?: string
  multiline?: boolean
  maxRows?: number
  readonly?: boolean
}

export const TextInput = (props: InputProps) => {
  const { control } = useFormContext();

  const controller: UseControllerReturn = useController({
    name: props.name,
    control,
  });


  return (
    <FormControl fullWidth>
      <TextField
        // InputProps={{sx: {height: 35}}}
        type={props?.type || 'text'}
        sx={{
          "& .MuiFormLabel-root": {
            fontSize: '0.9em'
          },
          "& .MuiInputBase-root": {
            fontSize: '0.9em'
          }
        }}
        variant="outlined"
        multiline={props.multiline}
        size="small"
        placeholder={props.placeholder}
        label={props.label}
        onChange={controller.field.onChange}
        onBlur={controller.field.onBlur}
        name={controller.field.name}
        maxRows={props.maxRows || ""}
        value={controller.field.value || ""}
        ref={controller.field.ref}
        error={!!controller.fieldState.error}
        helperText={controller.fieldState.error?.message}
        inputProps={{readOnly: props.readonly}}
        />
    </FormControl>
  );
};
